<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.professions', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card">
                    <div class="card-body p-1em">
                        <h3 class="card-title text-center mb-0">
                            {{ mProfession.name }}
                        </h3>
                    </div>
                    <b-container>
                        <div class="list-group list-group-flush">
                            <b-row>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.name') }}:

                                        <span class="font-weight-bold">
                                {{ mProfession.name }}
                            </span>
                                    </div>
                                </b-col>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.createdAt') }}:

                                        <span class="font-weight-bold">
                                {{ formattedDate(mProfession.created_at) }}
                            </span>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </b-container>
                    <b-container>
                        <b-row class="justify-content-sm-center" v-if="can">
                            <div class="card-footer text-right">
                                <b-button variant="primary" @click="updateProfession">
                                    {{ $t('message.edit') }}
                                </b-button>

                                <b-button v-b-modal.delete-modal variant="danger">
                                    {{ $t('message.delete') }}
                                </b-button>
                            </div>
                        </b-row>
                    </b-container>
                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.professions', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ mProfession.name }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deleteProfession">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';

    export default {
        name: "Profession",

        computed: {
            ...mapGetters(["profession",'hasAdminRole',
                'hasGestionnaireRole']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole;
            },

            mProfession: function() {
                return this.profession;
            }
        },

        data() {
            return {
                profession_id: this.$route.params.profession
            }
        },

        methods: {
            getProfession() {
                let args = {
                    profession: this.profession_id
                };

                this.$store.dispatch("getProfession", { args });
            },

            formattedDate(date) {
                return moment(date).format('DD-MM-YYYY HH:mm');
            },

            updateProfession() {
                this.$router.push({ name: 'edit-profession', params: { profession: this.profession_id } });
            },

            deleteProfession() {
                let self = this;
                let args = {
                    profession: this.profession_id
                };

                let successMessage = this.$i18n.t('message.professionDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteProfession', { args, index: self.profession_id, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                    this.$router.back();

                });
            }
        },

        mounted() {
            this.getProfession();
        }
    }
</script>

<style scoped>

</style>